import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { breakpoints, spaces } from '@99designs/emu/settings';

const Image = styled.img`
    ${mediaQuery.only('small')} {
        height: ${spaces['3bu']};
    }
`;

export function Logo() {
    return (
        // eslint-disable-next-line @next/next/no-html-link-for-pages
        <a href="/" data-testid="99designs-logo">
            <picture>
                <source
                    media={`(max-width: ${breakpoints.small[1]}px)`}
                    srcSet="https://assets.99static.com/logos/en/logomark_grey.svg"
                />
                <Image
                    src="https://assets.99static.com/logos/en/wordmark_grey.svg"
                    alt="99designs by Vista"
                />
            </picture>
        </a>
    );
}
